import React from 'react';
import { reduxForm, Field, submit } from 'redux-form';

import ConfirmModal from '../components/ConfirmModal/ConfirmModal';
import Spinner from '../components/Spinner';
import InputField from './InputField';
import { formatSaveStatus } from '../helpers/formatters';
import FormError from './FormError';

class InsuranceContractForm extends React.Component {
  state = {
    isOpenModal: false,
  };

  handleSubmit = () => {
    const { isInsuranceCanBeProvided } = this.props;
    if (isInsuranceCanBeProvided) {
      this.remoteSubmit();
    } else {
      this.setState({ isOpenModal: true });
    }
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  remoteSubmit = () => {
    const { dispatch } = this.props;
    dispatch(submit('insuranceContract'));
  };

  render() {
    const { isOpenModal } = this.state;
    const { handleSubmit, saveStatus, error } = this.props;
    const loading = saveStatus === 'PENDING';
    return (
      <div>
        <Spinner showLoader={loading} />
        <form onSubmit={handleSubmit}>
          <Field component={InputField} name="att_subscription" />
          <Field component={InputField} name="quick_subscription" />
          <Field component={InputField} name="device_id" />

          <button
            className="btn btn-default"
            disabled={loading}
            type="button"
            onClick={this.handleSubmit}
          >
            Save Contract
          </button>

          {error && <FormError error={error} />}

          <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
        </form>
        <ConfirmModal
          isOpen={isOpenModal}
          title="Confirm Create Contract"
          description={`The Customer is not qualified for device protection due to device protection not being offered in their state.`}
          onClose={this.closeModal}
          onConfirm={this.remoteSubmit}
        />
      </div>
    );
  }
}

const validate = (values) => {
  let errors = {};
  if (!values.att_subscription && !values.quick_subscription) {
    errors.att_subscription = 'Required';
    errors.quick_subscription = 'Required';
  }
  return errors;
};

InsuranceContractForm = reduxForm({
  form: 'insuranceContract',
  validate,
})(InsuranceContractForm);

export default InsuranceContractForm;
